import React from 'react';

function DrinkItem({ drink, quantity, onChange }) {
    return (
        <div className="drink-item">
            <div className="drink-info">
                <span className="drink-name">{drink.name}</span>
                <span className="drink-price">{Number(drink.price).toFixed(2)} €</span>
            </div>
            <div className="drink-controls">
                <button
                    className="drink-btn drink-btn--minus"
                    onClick={() => onChange(drink.id, -1)}
                    disabled={!quantity}
                    aria-label="Weniger"
                >−</button>
                <span className="drink-quantity">{quantity || 0}</span>
                <button
                    className="drink-btn drink-btn--plus"
                    onClick={() => onChange(drink.id, +1)}
                    aria-label="Mehr"
                >+</button>
            </div>
        </div>
    );
}

export default DrinkItem;
